import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'
import { CellLoader } from '~modals/SettingsModal/Preloader'

export function Preloader() {
    return (
        <div className={styles.tab}>
            <div className={styles.banner}>
                <Loader width="100%" height={80} />
            </div>

            <CellLoader />
            <CellLoader />
        </div>
    )
}
